import React, { useEffect, useState } from "react";
import AppLayout from "../components/AppLayout";
import { api, errMsg } from "../lib/api";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function TeammatesPage() {
  const [teammates, setTeammates] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const [tm, rs] = await Promise.all([api.get("/teammates"), api.get("/roles")]); setTeammates(tm.data); setRoles(rs.data); }
    catch(e){ toast.error(errMsg(e)); } setLoading(false);
  };
  useEffect(()=>{ load(); }, []);
  const add = async () => {
    try { const { data } = await api.post("/teammates", { data: { name:"New Teammate", location:"", phone:"", role_id:null, role_name:null, other_details:"" }}); setTeammates((x)=>[data, ...x]); } catch(e){ toast.error(errMsg(e)); }
  };
  const update = async (id, patch) => {
    setTeammates((xs)=>xs.map(t=>t.id===id?{...t,...patch}:t));
    try { await api.put(`/teammates/${id}`, { data: patch }); } catch(e){ toast.error(errMsg(e)); }
  };
  const remove = async (id) => {
    if (!window.confirm("Delete teammate?")) return;
    try { await api.delete(`/teammates/${id}`); setTeammates((xs)=>xs.filter(t=>t.id!==id)); } catch(e){ toast.error(errMsg(e)); }
  };

  return (
    <AppLayout>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-white" style={{fontFamily:'Outfit'}}>Teammates</h1>
          <p className="text-slate-400 mt-1">Reusable team-member records.</p>
        </div>
        <button onClick={add} data-testid="add-teammate-btn" className="bg-gradient-to-r from-blue-500 to-blue-700 text-white px-4 py-2 rounded-lg inline-flex items-center gap-2"><Plus size={14}/> New teammate</button>
      </div>
      <div className="pc-card overflow-x-auto" data-testid="teammates-table">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-widest text-blue-300/80 border-b border-slate-800">
            <tr>
              <th className="p-3">Name</th><th className="p-3">Location</th><th className="p-3">Phone</th><th className="p-3">Role</th><th className="p-3">Other details</th><th className="p-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800/60">
            {loading ? <tr><td className="p-6 text-slate-400">Loading…</td></tr>
              : teammates.length===0 ? <tr><td colSpan={6} className="p-10 text-center text-slate-400">No teammates yet.</td></tr>
              : teammates.map(t=> (
                <tr key={t.id} data-testid={`teammate-row-${t.id}`}>
                  <td className="p-2"><input value={t.name||""} onChange={(e)=>update(t.id,{name:e.target.value})} className="w-full bg-transparent border border-transparent hover:border-slate-700 focus:border-blue-500 rounded px-2 py-1 outline-none"/></td>
                  <td className="p-2"><input value={t.location||""} onChange={(e)=>update(t.id,{location:e.target.value})} className="w-full bg-transparent border border-transparent hover:border-slate-700 focus:border-blue-500 rounded px-2 py-1 outline-none"/></td>
                  <td className="p-2"><input value={t.phone||""} onChange={(e)=>update(t.id,{phone:e.target.value})} className="w-full bg-transparent border border-transparent hover:border-slate-700 focus:border-blue-500 rounded px-2 py-1 outline-none"/></td>
                  <td className="p-2">
                    <select value={t.role_id||""} onChange={(e)=>{ const r = roles.find(r=>r.id===e.target.value); update(t.id,{role_id:e.target.value||null, role_name:r?r.name:null}); }} className="bg-transparent border border-transparent hover:border-slate-700 focus:border-blue-500 rounded px-2 py-1 outline-none w-full">
                      <option value="">—</option>
                      {roles.map(r=><option key={r.id} value={r.id}>{r.name}</option>)}
                    </select>
                  </td>
                  <td className="p-2"><input value={t.other_details||""} onChange={(e)=>update(t.id,{other_details:e.target.value})} className="w-full bg-transparent border border-transparent hover:border-slate-700 focus:border-blue-500 rounded px-2 py-1 outline-none"/></td>
                  <td className="p-2"><button onClick={()=>remove(t.id)} className="text-slate-500 hover:text-rose-400" data-testid={`delete-teammate-${t.id}`}><Trash2 size={14}/></button></td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </AppLayout>
  );
}
